import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { INVENTORIES } from "MODULES/inventories/constants";
import { ACTIONS_REQUESTED, SHOP_ASSIST } from "MODULES/RepairOrders/constants";
import StatusBadges from "../../StatusBadges";

export default class ROLineItemsTable extends Component {
  static propTypes = {
    results: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired
      })
    ).isRequired,
    getField: PropTypes.func.isRequired,
    setField: PropTypes.func.isRequired,
    nested: PropTypes.bool,
    index: PropTypes.number,
    disabled: PropTypes.bool
  };

  fieldName = baseName => {
    if (this.props.index !== undefined) {
      return `line_items[${this.props.index}].${baseName}`;
    }
    return baseName;
  };

  handleChange = ({ id }) => {
    this.props.setField(this.fieldName("repaired_line_item_id"), id);
  };

  renderRow = (lineItem, i) => {
    const lineItemName =
      this.props.index !== undefined
        ? `line_items[${this.props.index}].repaired_line_item_id`
        : "repaired_line_item_id";
    const { disabled } = this.props;

    return (
      <tr key={i}>
        <td>{i + 1}</td>
        <td className="text-center">
          <input
            type="radio"
            name={`line_items[${this.props
              .index}][${lineItem.id}].read_only_repair_id`}
            className="radio-inline"
            checked={lineItem.id === this.props.getField(lineItemName)}
            onChange={() => this.handleChange(lineItem)}
            disabled={disabled}
          />
        </td>
        <td>{lineItem.part.part_number}</td>
        <td>{lineItem.serial_number}</td>
        <td>{ACTIONS_REQUESTED[lineItem.action_requested].label}</td>
        <td className="text-center">
          <StatusBadges status={lineItem.approval_status} />
        </td>
        <td>
          {lineItem.condition &&
            INVENTORIES.condition[lineItem.condition].abbrev}
        </td>
        <td className="text-center">{lineItem.quantity}</td>
      </tr>
    );
  };

  render() {
    const { nested, results = [] } = this.props;
    const classes = classNames(
      "table table-striped table-hover table-numbered",
      {
        nested
      }
    );
    return (
      <table className={classes}>
        <thead>
          <tr>
            <th />
            <th />
            <th>Part #</th>
            <th>Serial #</th>
            <th>ACTION REQ.</th>
            <th className="text-center">Status</th>
            <th>CD</th>
            <th className="text-center">QTY</th>
          </tr>
        </thead>
        <tbody>
          {results
            .filter(i => i.action_requested !== SHOP_ASSIST)
            .map(this.renderRow)}
        </tbody>
      </table>
    );
  }
}



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/FormSections/ActionRequested/ROLineItemsTable.jsx